export default __webpack_public_path__ + "static/media/Audio-Number-4.d826dec8.mp3";